/**
 * Presentation of an event type (see racing_events.md): the Vuetify colour of its chip and its icon.
 *
 * The mapping lives here and not in a component because the same type shows up in more than one
 * place — the chip of a card or of an event page, the trophy of an award won in it — and the two must
 * not drift apart. The icon says *what* the competition is, one per type:
 *
 * - `best_lap` / `best_lap_points`: one lap decides. A stopwatch for the time, a podium for the
 *   places (the lap scores, so the position is what counts).
 * - `best_session` / `best_session_points`: a run of consecutive laps. An hourglass for the total
 *   time — a duration, not a single lap — and a medal for the places.
 * - `stages`: the rally-style time trial: one attempt per track, flagged at the finish line.
 * - `monthly_season`: the championship of the month, and it keeps the cup: it is the one event that
 *   is a season in itself, so the cup is not spare for anything else.
 */

/** Colour of the chip and icon of every type. */
export const EVENT_TYPE_STYLES = {
  best_lap:            { color: 'blue',          icon: 'mdi-timer-outline' },
  best_lap_points:     { color: 'indigo',        icon: 'mdi-trophy' },
  best_session:        { color: 'teal',          icon: 'mdi-timer-sand' },
  best_session_points: { color: 'cyan-darken-2', icon: 'mdi-podium' },
  stages:              { color: 'deep-orange',   icon: 'mdi-trophy-award' },
  monthly_season:      { color: 'purple',        icon: 'mdi-trophy-variant' },
}

/** An unknown type — or none at all — gets a neutral chip and a certificate, never the cup. */
const FALLBACK_STYLE = { color: 'grey', icon: 'mdi-certificate-outline' }

/** Colour and icon of one event type; see FALLBACK_STYLE for anything not listed. */
export function eventTypeStyle(type)
{
  return EVENT_TYPE_STYLES[type] ?? FALLBACK_STYLE
}
